// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2j1As","header":"ReportDetails_header__2sdTk","title":"ReportDetails_title__1nWiz","left":"ReportDetails_left__1h5cF"};